import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import Sidebar from "./layout/Sidebar";

export default function CandidatePanel() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  const columns = [
    { name: "No",selector: (row,index) =>index+1,sortable: false},
    { name: "FullName", selector: row => row.fullname || "N/A", sortable: true },
    { name: "Course", selector: row => row.course.name || "N/A", sortable: true },
    { name: "Description", selector: row => row.description || "N/A", sortable: true },
    { name: "Score", selector: row => <button className="btn btn-success">{row.score}</button> || "N/A", sortable: true },
    { name: "Date Time", selector: row => new Date(row.createdOn).toLocaleString("en-GB") || "N/A", sortable: true },

  ];

  
  function searchHandler(e){
    e.preventDefault();
    const obj = new FormData(e.target);
    axios.get(`${process.env.REACT_APP_BASE_URL}api/candidate/secured/searchCandidateByLoginUser?start=`+obj.get('start')+"&end="+obj.get('end'))
    .then(result=>setData(result.data))
    .catch(err=>console.log(err))
  }
  function getData(){
      axios.get(`${process.env.REACT_APP_BASE_URL}api/candidate/secured/getCandidateByLoginUser`)
      .then(result=>setData(result.data))
      .catch(err=>console.log(err))
      .finally(setLoading(false));    
  }
  useEffect(()=>getData(),[]);

  const filteredData = filterText
    ? data.filter(item =>
        (item.fullname || "").toLowerCase().includes(filterText.toLowerCase())
      )
    : data;

    return (<>
      <div className="container-fluid">
          <div className="row">
             <div className="col-12 col-md-3 col-lg-2 sidebar-container">
                 <Sidebar></Sidebar>
             </div>
             <div className="col-12 col-md-9 col-lg-10 main-container">
                 <div className="container mt-4">
                  <h2 className="text-center mb-3">Candidate List</h2>
                  <hr />
    
                  {/* Action Buttons + Search Bar */}
                  <div className="row d-flex justify-content-between align-items-center mb-0">
                    <div className="col-12 col-lg-12">
                      <form onSubmit={searchHandler} className="row">
                        <div className="col-12 col-lg-2">
                           <input className="form-control" type="date" name="start" placeholder="From Date" />
                        </div>
                        <div className="col-12 col-lg-2">
                           <input className="form-control" type="date" name="end" placeholder="To Date" />
                        </div>
                        <div className="col-12 col-lg-2">
                           <input className="form-control btn btn-color" type="submit" value="search" />
                        </div>
                        </form>
                    </div>
                  </div>
                  {/* Data Table */}
                  <div className="card shadow" style={{overflow:"auto"}}>
                    <div className="card-body">
                      <DataTable
                        columns={columns}
                        data={filteredData}
                        progressPending={loading}
                        pagination
                        highlightOnHover
                        striped
                      />
                    </div>
                  </div>
                </div>
             </div>
          </div>
      </div> 
    </>);
}